import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty, isNumber } from 'lodash';
import { DEFAULT_INVALID_VALUE } from '../../utilities/FormattingUtilities';

export const useStyles = makeStyles((theme) => ({
    labelValueContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        marginTop: theme.spacing(1),
    },
    labelContainer: {
        fontWeight: 'bold',
        width: 180,
        whiteSpace: 'nowrap',
    },
    valueContainer: {
        paddingLeft: theme.spacing(2),
        width: 180,
        whiteSpace: 'nowrap',
    },
    valueContainerWrap: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        width: 'auto',
        maxWidth: 600,
    },
}));

export function NgpLabelValue({
    dataLabel,
    dataValue,
    showIfEmpty = false,
    dataValueClassName = '',
    labelContainerClassName = '',
    labelValueContainerClassName = '',
    wrap = false,
}) {
    const classes = useStyles();

    if (!showIfEmpty && isEmpty(dataValue) && !isNumber(dataValue)) {
        return null;
    }

    const valueClassName = clsx(classes.valueContainer, wrap && classes.valueContainerWrap, dataValueClassName);

    return (
        <div className={clsx(classes.labelValueContainer, labelValueContainerClassName)}>
            <div className={clsx(classes.labelContainer, labelContainerClassName)}>{dataLabel}</div>
            <div className={valueClassName}>{dataValue || DEFAULT_INVALID_VALUE}</div>
        </div>
    );
}
